import * as React from 'react';

interface WhatsAroundHeaderProps {
  title: string;
}

export const WhatsAroundHeader: React.FunctionComponent<WhatsAroundHeaderProps> = ({ title }) => (
  <div className="uitk-cell all-cell-1-1 all-x-padding-three all-y-padding-three">
    <h2 className="uitk-type-heading-600 uitk-type-bold">{title}</h2>
  </div>
);

WhatsAroundHeader.displayName = 'WhatsAroundHeader';
